module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("设备列表")]), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 0 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(0)
      }
    }
  }, [_vm._v("一体机")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 1 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(1)
      }
    }
  }, [_vm._v("一体机(二代)")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 2 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(2)
      }
    }
  }, [_vm._v("体检一体机")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 3 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(3)
      }
    }
  }, [_vm._v("智慧体育盒子")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 4 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(4)
      }
    }
  }, [_vm._v("智慧体育盒子(场馆监控)")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.currentIndex == 5 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickIndex(5)
      }
    }
  }, [_vm._v("坐位体前屈")])], 1), _vm._v(" "), (_vm.currentIndex == 0) ? _c('EquipmentAIO') : _vm._e(), _vm._v(" "), (_vm.currentIndex == 1) ? _c('EquipmentAIOTwo') : _vm._e(), _vm._v(" "), (_vm.currentIndex == 2) ? _c('EquipmentPhysical') : _vm._e(), _vm._v(" "), (_vm.currentIndex == 3) ? _c('EquipmentBox') : _vm._e(), _vm._v(" "), (_vm.currentIndex == 4) ? _c('EquipmentBoxVenue') : _vm._e(), _vm._v(" "), (_vm.currentIndex == 5) ? _c('EquipmentSit') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1861ab52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentList.vue
// module id = 956
// module chunks = 0